// FAB Button Manager

class FabButtonManager {
  constructor () {
    this._bVisible = true
    this._evListener = null
  }

  setVisible (bVisible) {
    // Dialog or form showing - call visible = false, on close on hide - call visible = true
    this._bVisible = bVisible
    if (this._evListener) {
      this._evListener(this._bVisible)
    }
  }

  clearEventListener () {
    this._evListener = null
  }

  setEventListener (eventListener) {
    this._evListener = eventListener
  }
}

export default new FabButtonManager()
